var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.7 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4,95c7.3,0,13.1-5.9,13.2-13.2H24.2C24.3,89.1,30.1,95,37.4,95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,62.7L65.1,49c-1.4-2.3-2.1-4.9-2.1-7.6v-5.5c0-11.5-7.3-22.1-18.2-25.4V7.4c0-4.1-3.3-7.4-7.4-7.4S30,3.3,30,7.4             v3.1c-10.5,3.2-18.2,12.9-18.2,24.4v6.5c0,2.7-0.7,5.3-2.1,7.6L1.3,62.7c-1.6,2.6-1.7,5.8-0.2,8.5s4.3,4.3,7.3,4.3h57.8             c3.1,0,5.8-1.6,7.3-4.3C75.1,68.5,75.1,65.3,73.5,62.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.79642d509e1629a316457790c1eb5976.svg";
export { ForwardRef as ReactComponent };